import { BannerAPIContentType } from '../../services/responseTypes/BannerApiResponse';
import { AssetDetails } from '../../services/responseTypes/singlePlayResponse';

export enum SUPPORTED_IMAGE_TYPE {
  JPG = '.jpg',
  PNG = '.png'
}
export interface GetImageURLProps {
  deviceWidth: number;
  tagName: string;
  isRequestedByBot?: boolean;
  item: BannerAPIContentType | AssetDetails;
}
